import { render, staticRenderFns } from "./EmployeeListPageTableComponent.vue?vue&type=template&id=0966eea0&"
import script from "./EmployeeListPageTableComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeeListPageTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports